<!-- Image column -->
<div data-aos="fade-up" class="order-3 lg:order-none">
  <div class="rounded-[20px]">
    <app-responsive-img
      name="hire-2"
      [alt]="'talentSearchV2.ranking.imageAlt' | translate"
      imgClass="w-full h-auto block select-none pointer-events-none rounded-xl"
      sizes="(min-width: 1024px) 50vw, 100vw"
    />
  </div>
</div>

<!-- Text column -->
<div data-aos="fade-up" data-aos-delay="150" class="order-4 lg:order-none">
  <!-- Kicker -->
  <span
    class="block text-[10px] font-bold uppercase tracking-[2px] mb-5"
    style="color: #838A98;">
    {{ 'talentSearchV2.ranking.kicker' | translate }}
  </span>

  <!-- Heading -->
  <h2 class="text-3xl md:text-[44px] lg:text-[52px] font-black leading-[1.1] tracking-tight text-[#061430]"
      [innerHTML]="'talentSearchV2.ranking.title' | translate | accent">
  </h2>

  <!-- Subtitle -->
  <p class="text-base text-[#555] max-w-[380px] mt-5 mb-6 leading-relaxed">
    {{ 'talentSearchV2.ranking.desc' | translate }}
  </p>

  <!-- Compare: Old way vs Uptal way -->
  <div class="grid grid-cols-2 gap-3 mb-8" data-aos="fade-up" data-aos-delay="100">
    <!-- Old way -->
    <div class="rounded-xl bg-[#F3F5F9] px-4 py-3.5">
      <div class="flex items-center gap-2 mb-2">
        <span class="w-6 h-6 rounded-full bg-[#FFE9E7] flex items-center justify-center">
          <app-icon name="cancel" [size]="15" class="text-[#FF6767]"/>
        </span>
        <span class="text-sm font-semibold leading-4 text-[#3F3F46]">
          {{ 'talentSearchV2.ranking.oldWayLabel' | translate }}
        </span>
      </div>
      <p class="text-sm leading-[14px] font-medium text-[#3F3F46] mb-0.5">
        {{ 'talentSearchV2.ranking.oldWayLine1' | translate }}
      </p>
      <p class="text-xs leading-[18px] font-normal text-[#888]">
        {{ 'talentSearchV2.ranking.oldWayLine2' | translate }}
      </p>
    </div>

    <!-- Uptal way -->
    <div class="rounded-xl bg-[#F3F5F9] px-4 py-3.5">
      <div class="flex items-center gap-2 mb-2">
        <span class="w-6 h-6 rounded-full bg-[#D9F7BE] flex items-center justify-center">
          <app-icon name="check_circle" [size]="15" class="text-[#3EBB5A]"/>
        </span>
        <span class="text-sm font-semibold leading-4 text-[#3F3F46]">
          {{ 'talentSearchV2.ranking.uptalLabel' | translate }}
        </span>
      </div>
      <p class="text-sm leading-[14px] font-medium text-[#3F3F46] mb-0.5">
        {{ 'talentSearchV2.ranking.uptalLine1' | translate }}
      </p>
      <p class="text-xs leading-[18px] font-normal text-[#888]">
        {{ 'talentSearchV2.ranking.uptalLine2' | translate }}
      </p>
    </div>
  </div>

  <!-- CTA -->
  <button
    type="button"
    (click)="openBookDemo()"
    class="inline-flex items-center gap-2 text-sm font-semibold rounded-full bg-primary shadow-[0px_4px_16px_0px_#353CD84D] text-white py-4 px-8 transition-all hover:brightness-105">
    {{ 'talentSearchV2.ranking.cta' | translate }}
    <span class="inline-grid place-items-center rtl:flip"><app-icon name="tabler:arrow-narrow-right" [size]="18"/></span>
  </button>
</div>
